import { Link } from 'react-router-dom';
import type { Language } from '../content/content';
import { content } from '../content/content';

type BrandHeaderProps = {
  language: Language;
  compact?: boolean;
};

export function BrandHeader({ language, compact = false }: BrandHeaderProps) {
  const copy = content[language];

  return (
    <header className={compact ? 'brandHeader brandHeaderCompact' : 'brandHeader'}>
      <Link to="/" className="brandMark" aria-label={copy.backHome}>
        <img src="/brand/logo.png" alt="Albania Restaurante" />
      </Link>
    </header>
  );
}
